/**
 * 数値が0以上かどうか判定する関数
 * @param num
 * @returns
 */
export const exist = (num: number) => {
  if (typeof num !== 'number') return false
  return num && num >= 0
}

export const notExist = (num: number) => {
  // return !num || num == null || num < 0
  return num == null || num < 0
}

/**
 * オブジェクト同士の比較を行う関数
 * @param a オブジェクトA
 * @param b オブジェクトB
 * @returns 比較結果
 */
export const compareObj = (a: object, b: object) => {
  return JSON.stringify(a) === JSON.stringify(b)
}

/**
 * オブジェクト配列同士の比較を行う関数
 * @param a オブジェクト配列A
 * @param b オブジェクト配列B
 * @returns 比較結果
 */
export const compareObjArray = (a: object[], b: object[]) => {
  if (a.length !== b.length) return false
  for (let i = 0; i < a.length; i++) {
    if (!compareObj(a[i], b[i])) return false
  }
  return true
}

/**
 * 受領条件画面チェック判定関数
 */
type jokenKey = { [K in 'TOKUI_CD' | 'TEN_CD' | 'DENPYO_NO' | 'GYO_NO' | 'JCU_KBN']: number | string }
export const isUniqueJuryo = (obj1: jokenKey, obj2: jokenKey) => {
  return obj1.TOKUI_CD === obj2.TOKUI_CD && obj1.TEN_CD === obj2.TEN_CD && obj1.DENPYO_NO === obj2.DENPYO_NO && obj1.GYO_NO === obj2.GYO_NO && obj1.JCU_KBN === obj2.JCU_KBN
}

/**
 * 受領条件画面チェック判定関数
 */
type tokuiTenKey = { [K in 'TOKUI_CD' | 'TEN_CD']: number | string }
export const isUniqueTokui = (obj1: tokuiTenKey, obj2: tokuiTenKey) => {
  return obj1.TOKUI_CD === obj2.TOKUI_CD && obj1.TEN_CD === obj2.TEN_CD
}

/**
 * 販売条件明細画面チェック判定関数
 */
type jokenDetailKey = { [K in 'ADD_YMD' | 'ADD_HNS' | 'JP_CD' | 'NET']: number | string }
export const isUniqueJokenDetail = (obj1: jokenDetailKey, obj2: jokenDetailKey) => {
  return obj1.ADD_YMD === obj2.ADD_YMD && obj1.ADD_HNS === obj2.ADD_HNS && obj1.JP_CD === obj2.JP_CD && obj1.NET === obj2.NET
}

/**
 * ユーザー登録サマリ画面チェック判定関数
 */
type userKey = { [K in 'JIGYO_CD' | 'MAIL' | 'TOKUI_CD' | 'TEN_CD']: number | string }
export const isUniqueUser = (obj1: userKey, obj2: userKey) => {
  return obj1.JIGYO_CD === obj2.JIGYO_CD && obj1.MAIL === obj2.MAIL && obj1.TOKUI_CD === obj2.TOKUI_CD && obj1.TEN_CD === obj2.TEN_CD
}
